import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xtxmiyuigxnuasxhpcnh.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh0eG1peXVpZ3hudWFzeGhwY25oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0MTMxNjcsImV4cCI6MjA2OTk4OTE2N30.00pW6ylYmx5uUoTd-eMPBQ92pbZunKc5JHHVVOJlpdE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
